import type { RelatedSource } from "epsm-api-types/models";
import { formatDateToFullTime } from "@/lib/utils/formatDateToFullTime/formatDateToFullTime";

type Props = {
	relatedSources: RelatedSource[];
};

export const RelatedSources: React.FC<Props> = ({ relatedSources }) => {
	return (
		<div className="flex flex-col gap-2">
			<p className="font-bold">Related sources</p>

			{relatedSources.map((source) => {
				const { title, author, publication_date, summary, url, _id } =
					source as RelatedSource & { _id: string };
				const date = publication_date && new Date(publication_date);
				const time = date && formatDateToFullTime(date);

				return (
					<a
						href={url}
						target="_blank"
						key={_id}
						className="p-2 border rounded-lg border-border-main flex flex-col gap-1"
						rel="noreferrer"
					>
						<h2 className="font-bold text-gold">{title}</h2>
						<p>{`${author} ${!!date && `/ ${time}`}`}</p>
						<p>{summary}</p>
					</a>
				);
			})}
		</div>
	);
};
